export default __webpack_public_path__ + "static/banner-renovation-tips-and-insights-c0ea10cebc1d8ec9ec6c1fadc5bb3a57.jpg";